import { render } from "./bymyClassify.vue?vue&type=template&id=52fcd7b0&scoped=true"
import script from "./bymyClassify.vue?vue&type=script&lang=js"
export * from "./bymyClassify.vue?vue&type=script&lang=js"

import "./bymyClassify.vue?vue&type=style&index=0&id=52fcd7b0&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52fcd7b0"]])

export default __exports__